export default "__VITE_ASSET__gF$0Qfrs__"